import striptags from "striptags";
import {mysql2Date} from "@/utils/date";

/**
 * Sort items *at place* by auth list.
 * @param items
 * @param topicSort is a list of auths in needed order
 * @returns {*}
 */
export const sortByAuth = (items, authSort, key="auth") => {
    if ( !items ) return;
    if ( !authSort ) return;
    const indexes = {};
    const indexOfAuth = (auth) => {
        let index = -1;
        if (indexes[auth]) index = indexes[auth];
        else if (Array.isArray(authSort)) index = indexes[auth] = authSort.findIndex(el => el === auth);
        return index;
    }
    items.sort((a, b) => {
        const aIndex = indexOfAuth(a[key]);
        //console.log("A. "+a.auth+": "+aIndex);
        const bIndex = indexOfAuth(b[key]);
        //console.log("B. "+b.auth+": "+bIndex);
        return aIndex - bIndex;
    });
};

export const sortByActivity = (items, key="activityAt") => {
    if ( !items ) return;
    items.sort((a, b) => {
        return new Date(b[key]) - new Date(a[key]);
    });
};

/**
 * Insert item into a groups list right below existing pinned/favorite items, since a freshly
 * created group has the most recent activity of all unpinned items.
 */
export const insertGroupByActivity = (items, item) => {
    if ( !items ) return;
    const index = items.findIndex(el => !el.isFav);
    if (index === -1) items.push(item);
    else items.splice(index, 0, item);
};